module.exports = __webpack_public_path__ + "img/3.3f7f903e.jpg";